import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { BHPayment } from './BHPayment.js';

@Entity()
export class BHInvoice extends MongoEntity {
  static override _class = 'BHInvoice';
  static override _collectionName = 'invoices';

  @Field(type => String)
  userID!: string;

  @Field(type => String)
  institutionID!: string;

  @Field(type => String)
  paymentID!: string;

  @DataLoadedField(type => BHPayment, ({ paymentID }) => paymentID)
  payment!: BHPayment;

  @Field(type => String)
  pdfID!: string;

  @DataLoadedField(type => AdornisFile, ({ pdfID }) => pdfID)
  pdf!: AdornisFile;

  @Field(type => Date, { default: it => it ?? new Date() })
  created!: Date;

  @Field(type => Date)
  sentDate: Maybe<Date>;
}
